//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import globalMixin from "@/lib/global";
import vuexMixin from "@/lib/vuexMixin";

export default {
  mixins: [globalMixin, vuexMixin],
  name: "HeaderLayout",
  props: ["withoutCategory"],
  computed: {
    profile: {
      get () {
        return this.getProfileSelected
      },
      set (value) {
        this.setProfileSelected(value)
      }
    },
  },
  async fetch() {
    try {
      const data = await fetch(
        `${process.env.VUE_APP_API_URL}/categories`
      ).then((res) => res.json());
      this.itemsOrganized = data.sort(function (a, b) {
        var textA = a.name.toUpperCase();
        var textB = b.name.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
      this.itemsRandomized = Array.from(data).sort(() => Math.random() - 0.5);
      this.loading = false;
      return;
    } catch (error) {
      console.log("Error in HeaderLayout, fetch categories: ", error);
      return [];
    }
  },
  data: () => ({
    searchField: null,
    expand: false,
    loading: true,
    itemsRandomized: [],
    itemsOrganized: [],
  }),
  methods: {
    // async getCategories() {
    // try {

    //   if(this.itemsRandomized.length > 0){
    //     return;

    //   }
    //   const categoriesInfo = await this.requestEds('GET', 'categories')
    //   this.itemsOrganized = categoriesInfo.data.sort(function(a, b) {
    //     var textA = a.name.toUpperCase();
    //     var textB = b.name.toUpperCase();
    //     return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    //   });
    //   this.itemsRandomized = Array.from(categoriesInfo.data).sort(() => Math.random() - 0.5).slice(0,5)
    //   this.loading = false
    //   return
    //   }
    //   catch(error) {
    //     return error.response.status
    //   }
    // },
    toRedirectPortal(){
      if(this.profile === 'Administrador'){
        this.$router.push(`/admin/apis`);
      }else if(this.profile === 'Usuário'){
        this.$router.push(`/admin/apiConsumed`);
      }
    },

    goToHome() {
      this.$router.push(`/home`);
    },
    details(path, id) {
      this.$router.push({
        path,
        query: {
          id: id,
        },
      });
    },
    openCategory(id) {
      this.$router.push(`/home/${id}`);
    },
    submit(event) {
      event.preventDefault();
      if (!this.searchField || this.searchField == "") {
        this.$router.push(`/home`);
        return;
      }
      this.$router.push(`/home/search/${this.searchField}`);
      this.searchField = "";
      event.target.blur();
    },
  },
};
